function employeeNumberValidate() {
  const employeeNumberInput = document.querySelector('.employeeNumberValidate');
  let url = window.location.href;
  let executorId = getNumberFromUrl(url);
    console.log(executorId)

  employeeNumberInput.addEventListener('blur', function () {
    checkUserEmployeeNumberExists(
      employeeNumberInput.value,
      employeeNumberInput,
        executorId
    );
  });
}

function checkUserEmployeeNumberExists(employeeNumber, employeeNumberInput, executorId) {
  const errorDiv = document.getElementById('employeeNumberError');
  $.ajax({
    type: 'POST',
    url: `/api/user/employee-number/check/`,
    data: {
      employeeNumber: employeeNumber,
    },
    success: function () {
      errorDiv.classList.add('is-hidden');
      employeeNumberInput.classList.remove('is-danger');
    },
    error: function () {
      errorDiv.classList.remove('is-hidden');
      employeeNumberInput.classList.add('is-danger');
    },
  });
}

function getNumberFromUrl(url) {
    return url.split('/').filter(function(part) {
        return part !== "" && !isNaN(part);
    });
}
